import { useEffect } from "react";
import { gameUiVisibleState } from "@atom/ui/gameUiState";
import { useSetRecoilState } from "recoil";

export const useGameUiNavVisible = (visible: boolean) => {
  const setGameUiVisible = useSetRecoilState(gameUiVisibleState);

  useEffect(() => {
    setGameUiVisible(visible);
    return () => setGameUiVisible(!visible);
  }, [setGameUiVisible]);
};  